const getProposalUrlWithoutStep = (url) => {
    const indexOfStep = url.indexOf("devis") + 5;
    return url.slice(0, indexOfStep);
}

export const getProposalImageAssetUrl = (url, image) => {
    const urlWithoutStep = getProposalUrlWithoutStep(url);
    return `${urlWithoutStep}/assets/images/${image}`;
}

export const getProposalUrlWithExtra = (url, extra) => {
    const urlWithoutStep = getProposalUrlWithoutStep(url);
    return `${urlWithoutStep}${extra}`;
}

export const getImageAssetUrl = (image) => {
    const basePath = window.location.hostname === "localhost" ? "" : "/particuliers/auto/assurance-auto-usage";
    return `${basePath}/assets/images/${image}`;
}